import React, { useState, useEffect, useRef } from 'react';
import { useParams,useNavigate } from "react-router-dom";
import {API_SERVER_URL} from "../../utils/config_ip_details";
import {OVERVIEW_META_DATA} from "../../utils/config_mapping";
import {getFilenameFromURL,cutString,loader,capitalizeFirstLetterOfEachWord} from "../../utils/common_functions"
import {apiCall} from "../../utils/server_utils"
import CommonIcon from '../common/customicon';
import {trackError} from "../../utils/error_tracker"
// import PdfHighlighter from '../../utils/pdf-highlighter';
import {API_SUCCESS_RESPONSE_CODE} from "../../utils/config_mapping"
import $ from "jquery";
import PageLoader from '../common/pageloader';

export const DocumentDetails = () => {
  const navigate = useNavigate();
  const gobacktodoucment = (event) => {
    navigate("/document-list")
  }
  const {documentid,documentname,type} = useParams(); // Extract the `id` parameter from the URL
  const [data, setData] = useState(""); // State to hold API data
  const [tabledata, setTableData] = useState([]); // State to hold API data
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [loading, setLoading] = useState(true); // State to track loading
//   const [searchText, setSearchText] = useState("");

  const [input, setInput] = useState('');
  const [conversationHistory, setConversationHistory] = useState([]);
  const [askgenieloading, setAskgenieLoading] = useState(false); // State for loader
  const messagesContainerRef = useRef(null); // Reference to the chat message container

 //#-- Tab
 const [activeTab, setActiveTab] = useState('overview-tab');  // State for active tab
 const handleTabChange = (tabId) => {
   setActiveTab(tabId);
 };
 //#--

 //#-- Inner Tab
 const [activeInnerTab, setActiveInnerTab] = useState('show-clauses-tab');
 const handleInnerTabChange = (tab) => {
   setActiveInnerTab(tab);
 };

 //#--Accordion
 const [openItem, setOpenItem] = useState(null); // Track only one open item
 const toggleAccordion = (key) => {
   setOpenItem(prevKey => (prevKey === key ? null : key)); // Open clicked item, close others
 };

const [iframeSrc, setIframeSrc] = useState("");
 
   // Fetch data from the 
   const highlightWord = async (pmText) => {
       let request_object = {}
       request_object.pdf_url = data["FilePath"]
       request_object.sentence = pmText
         let apiUrl = API_SERVER_URL+ 'contracts/pdf-highlighter/'
         let method = "POST"
         try {
             const result = await apiCall(method,apiUrl,request_object);
             if(result!==undefined){
             if (result.code === API_SUCCESS_RESPONSE_CODE) {
              //&zoom=75&toolbar=0&navpanes=0
               setIframeSrc(result.data.highlighted_pdf_url+"#page="+result.data.page_no);
             } else {
               trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
             }
             }
         } catch (error) {
           console.error("Error refreshing token:", error);
         }
 }

  useEffect(() => {
   const fetchData = async () => {
      try {
        const apiUrl = ""
        const method = "" 
        const result = await apiCall("GET", `${API_SERVER_URL}contracts/`+documentid+`/`);
        if(result!==undefined){
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
          setData(result.data);
          setIframeSrc(result.data.pdf_temp_url);
          if (result.data && result.data.table_data && result.data.table_data.length > 0){
               setTableData(result.data.table_data);
               setFilteredTableData(result.data.table_data);
          }
        } else {
          trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
        }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }finally {
         setLoading(false); // Stop loading spinner
         if(type === "askgenie"){
            const timer = setTimeout(() => {
               handleTabChange('content')
               handleInnerTabChange('askgenie-tab')
             }, 500);

           }  
      }
    };
    fetchData();
   // Fetch data from the API
   //  const fetchData = async () => {
   //    try {
   //      const response = await fetch(API_SERVER_URL+"documents/"); // Replace with your API URL
   //      const result = await response.json();
   //      if (result.status === "success") {
   //        setData(result.data[0]);
   //      }
   //    } catch (error) {
   //      setLoading(false); // Set loading to false after data is fetched
   //      console.error("Error fetching data:", error);
   //    } finally {
   //      setLoading(false); // Stop loading spinner
   //    }
   //  };
   //  fetchData();

  }, []); // Empty dependency array ensures this runs only once

 
  useEffect(() => {
   // Fetch data from the API
   const handleAakGenie = async () => {
       let request_object = {}
       request_object.doc_id = "doc-boofv70zg"
       request_object.query = "What is expiry date"
      
         let apiUrl = API_SERVER_URL+ 'chat/'
         let method = "POST"
         try {
             const result = await apiCall(method,apiUrl,request_object);
             if(result!==undefined){
             if (result.code === API_SUCCESS_RESPONSE_CODE) {
                
             } else {
               trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
             }
             }
         } catch (error) {
           console.error("Error refreshing token:", error);
         }
       
 };
 //handleAakGenie();
},[])

  useEffect(() => {

   // Fetch data from the API
    const fetchPdfPageInfo = async () => {
      try {
         const apiUrl = ""
         const method = "" 
         const result = await apiCall("GET", `${API_SERVER_URL}contracts/`+documentid+`/pdf-info/`);  
         if (result.status === "success") {
            // setData(result.data[0]);
         }
      } catch (error) {
      }
    };
    //fetchPdfPageInfo();
  },[])

  useEffect(() => {
   if (filteredTableData.length > -1) {
     // Destroy the existing DataTable if it exists
     const table = $("#contract_grid").DataTable({
       data: filteredTableData,
       destroy: true, // Ensure the previous table is destroyed
       columns: [
         { data: "Documentname", title: "Document Name", width: "20px" },
         { data: "Properties", title: "Properties", width: "20px" },
         { data: "Categories", title: "Categories", width: "10px" },
         { data: "SubCategories", title: "SubCategories", width: "10px" },
         { data: "Channels", title: "Channels", width: "10px" },
         { data: "Teritory", title: "Teritory", width: "10px" },
         { data: "UserGroups", title: "UserGroups", width: "10px" },
       ],
       paging: false,
       searching: false,
       ordering: true,
       responsive: true,
       fixedHeader: true,
       scrollY: "300px",  // Set the fixed height for vertical scroll
       scrollCollapse: true,  // Collapse the height if less data
       language: {
         emptyTable: "No data found matching the filters",  // Custom message for no data
       },
     });

     $('.menu-icon').on('click', function() {
      // Adjust DataTable columns and redraw when the sidebar menu is toggled
      setTimeout(function() {
        table.columns.adjust().draw();
      }, 100); // Adjust the delay time based on your sidebar transition duration
    });

   // Use ResizeObserver to detect changes in div size
   const container = document.getElementById("contract_grid");
   const resizeObserver = new ResizeObserver(() => {
     table.columns.adjust().draw();  // Adjust and redraw table on div resize
   });

   // Start observing the size changes of the div
   if (container) {
     resizeObserver.observe(container);
   }

   // Cleanup on unmount
   return () => {
     table.destroy();  // Clean up DataTable instance
     if (container) {
       resizeObserver.unobserve(container);  // Stop observing the div
     }
   };
 }
 }, [filteredTableData]);


 //#- Ask Genie 
 const handleSendMessage = async () => {
   if (!input.trim()) return;

   const userMessage = { type: 'sent', message: input };
   setConversationHistory([...conversationHistory, userMessage]);

   let request_object = {
       doc_id: data["BioworldDocumentNo"], // Replace with actual document ID
       query: input,
   };

   let apiUrl = `${API_SERVER_URL}chat/`;
   let method = "POST";
   setAskgenieLoading(true); // Show loader while waiting for the response

   try {
       const result = await apiCall(method, apiUrl, request_object);
       setAskgenieLoading(false); // Hide loader after getting the response
       if (result && result.code === API_SUCCESS_RESPONSE_CODE) {
           const apiAnswer = result.data.answer || "No answer found.";
           const apiResponse = { type: 'replies', message: apiAnswer };
           setConversationHistory([...conversationHistory, userMessage, apiResponse]);
       } else {
           console.error("Invalid API response", result);
       }

   } catch (error) {
       setLoading(false); // Hide loader if there's an error
       console.error("Error fetching data:", error);
   }
   setInput('');
};

useEffect(() => {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map((tooltipTriggerEl) => new window.bootstrap.Tooltip(tooltipTriggerEl));
  // Cleanup tooltips on component unmount
  return () => {
    tooltipTriggerList.map((tooltipTriggerEl) => {
      const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
      if (tooltip) tooltip.dispose();
    });
  };
}, []);

    // Auto-scroll to the latest message
    useEffect(() => {
      if (messagesContainerRef.current) {
          messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
      }
  }, [conversationHistory]);
  return (
        <div className="main-content">
        <div className="page-content">
            <div className="container-fluid">
           <>
                <div className="flex-grow-1">
                    <div className="page-title">Contract Intelligence</div>
                    <p className="text-muted my-2 ff-secondary">
                    <a href="javascript:void()" onClick={gobacktodoucment}><i className="las la-arrow-circle-left fs-14"></i></a><CommonIcon iconName="FileText" size={"17px"} color="#6B7280"  /> {documentname}
                    </p>
                </div>
                <div id="app_err"></div>
                {loading === true ? (
                 <PageLoader />
            ) :  data !=="" ?
                (
                <>
               <div className="d-flex mt-4">
               <div className="card">
               <div className="card-body" style={{padding:"5px"}}>
               <ul className="nav nav-pills animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1" role="tablist">
                <li className="nav-item">
                   <a             className={`nav-link fs-14 ${activeTab === 'overview-tab' ? 'active' : ''}`} 
            data-bs-toggle="tab" 
            href="javascript:void(0)" 
            role="tab"
            onClick={() => handleTabChange('overview-tab')}
>
                   <i className="ri-airplay-fill d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="FileText" size={"17px"} color={activeTab === 'overview-tab' ? '#fff' : '#000'}  /> Overview</span>
                   </a>
                </li>
                <li className="nav-item">
                   <a className={`nav-link fs-14 ${activeTab === 'content' ? 'active' : ''}`} 
            data-bs-toggle="tab" 
            href="javascript:void(0)" 
            role="tab"
            onClick={() => handleTabChange('content')}
>
                   <i className="ri-list-unordered d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="BookOpen" size={"17px"} color={activeTab === 'content' ? '#fff' : '#000'}  /> Content</span>
                   </a>
                </li>
             </ul>
             </div>
             </div>
                </div>
                <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                <div className="row">
                                <div className="col-md-12">
                                <div>
          <div className="tab-content pt-0 text-muted">
             <div className={`tab-pane ${activeTab === 'overview-tab' ? 'active' : ''}`} id="overview-tab" role="tabpanel">
             <div className="card">
             <div className="card-body">
                <div className="row">
                   <div className="col-md-12">
                            <h5 className="card-title mb-3">Contract Meta Data</h5>
                            <div className="row">
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["FilePath"]["label"]]}<br/><span className="overview-value">{getFilenameFromURL(data["FilePath"])}</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["BioworldDocumentNo"]["label"]]}<br/><span className="overview-value">{data["BioworldDocumentNo"]}</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["documenttype"]["label"]]} <br/><span className="overview-value">{data["documenttype"]}</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["licensor"]["label"]]} <br/><span className="overview-value">{data["licensor"]}</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["version"]["label"]]} <br/><span className="overview-value">1.0</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["expirationdate"]["label"]]} <br/><span className="overview-value">{data['items']["expirationdate"]['value']}</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["effectivedate"]["label"]]} <br/><span className="overview-value">{data['items']["startdate"]['value']}</span></span></div>
                            <div className="col-lg-3 mb-2"><span className="overview-label">{[OVERVIEW_META_DATA["sell-off period"]["label"]]} <br/><span className="overview-value">{data['items']["sell-off period"]['value']} {data['items']["sell-off period"]['value']!=="NA" ? [OVERVIEW_META_DATA["sell-off period"]["units"]] :""}</span></span></div>
                            </div>
                          
                         
                     
                   </div>
                </div>
             </div>
             </div>

             <div className="card mt-3">
             <div className="card-body">
                            <h5 className="card-title mb-3">Contract Details</h5>
                            <div className="row">
                              {
                                 tabledata.length > 0 ? 
                                 <table
                                 id="contract_grid"
                                 className="display"
                                 style={{ width: "100%" }}
                               >
                               <thead>
                               </thead>
                               </table> : 
                                 <div className="col-lg-3 mb-2">No Details Found</div>

                              }
                            </div>
             </div>
             </div>

             </div>
             <div className={`tab-pane ${activeTab === 'content' ? 'active' : ''}`} id="content" role="tabpanel">

                <div className="row">
                    <div className="col-lg-8">
                     {/* {'https://mozilla.github.io/pdf.js/web/viewer.html?file='} */}
                     {
                        iframeSrc==="" ?   
                        <p className="center">No PDF URL Found</p>
                        :
                    <iframe 
                    id="loadPdf" style={{display:"block"}} 
                    src={encodeURIComponent(iframeSrc)}
                    width="100%"
                    height="960" 
                    type="application/pdf"></iframe>

                     }
                    </div>
                    <div className="col-lg-4">
                    <div class="panel panel-default">
                    <div class="panel-heading">
                    <ul className="nav nav-pills content-inner-tab gap-2 gap-lg-3 flex-grow-1" role="tablist">
                    <li className="nav-item">
                    <a href='javascript:void(0)' className={`nav-link fs-14 ${activeInnerTab === 'show-clauses-tab' ? 'active' : ''}`}
                        onClick={() => handleInnerTabChange('show-clauses-tab')}
>
                    <i className="ri-airplay-fill d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="BookOpen" size={"17px"} color="#000"  /> Show Clauses</span>
                    </a>
                    </li>
                    <li className="nav-item ask-genie-fullwidth">
                    <a href='javascript:void(0)' className={`nav-link fs-14 ${activeInnerTab === 'askgenie-tab' ? 'active' : ''}`}
                        onClick={() => handleInnerTabChange('askgenie-tab')}
                        role="tab"
>
                    <i className="ri-list-unordered d-inline-block d-md-none"></i> <span className="d-none d-md-inline-block"><CommonIcon iconName="WandSparkles" size={"17px"} color="#000"  /> AskGenie</span>
                    </a>
                    </li>
                    </ul>
                    </div>
                    <div class="panel-body">
                    <div className="tab-content text-muted">
                    <div className={`tab-pane ${activeInnerTab === 'show-clauses-tab' ? 'active' : ''}`} id="show-clauses-tab" role="tabpanel">
                    <div className="accordion custom-accordionwithicon accordion-fill-primary" id="accordionFill">
                                  {Object.entries(data.items).map(([key, item]) => (
                                     <div className="accordion-item material-shadow">
                                     <h2 className="accordion-header" id={key}>
                                     <button
                                                       className={`accordion-button ${openItem === key ? '' : 'collapsed'}`}
                                                       type="button"
                                                       onClick={() => toggleAccordion(key)}
                                                       aria-expanded={openItem === key ? 'true' : 'false'}
                                                       aria-controls={"content_" + key}
                                         
                                          >
                                         {(OVERVIEW_META_DATA[key] && typeof OVERVIEW_META_DATA[key].label === 'string') 
                                          ? capitalizeFirstLetterOfEachWord(`${OVERVIEW_META_DATA[key].label} (${item.sentences.length})`)
                                          : capitalizeFirstLetterOfEachWord(`${key} (${item.sentences.length})`)}


                                       </button>
                                     </h2>
                                    <div 
                                                id={"content_" + key}
                                                className={`accordion-collapse collapse ${openItem === key ? 'show' : ''}`}
                                                aria-labelledby={key}
                                                data-bs-parent="#accordionFill"
                                    >
                                    <div className="accordion-body">
                                    {item.sentences.length > 0 ? (
                                        <div>
                                        {item.sentences.map((sentence, index) => (
                                        <>  
                                        <p className="text-muted my-2 ff-secondary">{index+1}.{cutString(sentence,60)}</p>
                                        <button 
                                        onClick={() => highlightWord(sentence)} // Pass a function reference
                                        type="button" className="btn btn-primary btn-sm mb-2">Click to view contract clause</button> 
                                        </>  
                                        ))}
                                        </div>) : (
                                        <p className="text-muted my-2 ff-secondary">No sentences available</p>
                                        )}
                                    </div>
                                    </div>
                                 </div>
                                  ))}
                    </div>
                    </div>
                    <div className={`tab-pane ${activeInnerTab === 'askgenie-tab' ? 'active' : ''}`}  id="askgenie-tab" role="tabpanel">

                    <div id="frame">
                  <div className="content">
                    

                        {conversationHistory.length === 0  ?
                        <div className="askgenie-centered-container text-center">
                              <div className="mb-5">
                              <CommonIcon iconName="Sparkles" size={"55px"} color="#a25ddc"  />
                              </div>
                              <h5 className="mb-3" >Contract Intelligence at Your Service</h5>
                              <p>Ask me anything about this document. I can help you understand clauses, extract key information, or analyze specific sections.</p>
                        </div> : ""
                        }
                  


                     <div className="messages" ref={messagesContainerRef}>
                    <ul>
                        {conversationHistory.map((msg, index) => (
                            <li key={index} className={msg.type}>
                                <p>{msg.message}</p>
                            </li>
                        ))}
   {/* Loader while waiting for the API response */}
   {loading && (
<li className="loading">
    <div className="loader">
    <CommonIcon iconName="RefreshCcw" size={"17px"} color="#fff"  />
    </div>
</li>
)}
                     
                    </ul>
                </div>

                <div className="message-input">
                    <div className="wrap">
                   
                   <div className='row'>
                              {/* <div className='col-md-1'>
                              <CommonIcon iconName="RefreshCw " size={"30px"} color="#000"  />
                              </div> */}
                              <div className='col-md-10'>
                        {/* <input
                            type="text"
                            className='form-control'
                            placeholder="Ask me anything about this document"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                        /> */}
                        <textarea 
                        className='form-control'
                        placeholder="Ask me anything about this document"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault(); // Prevents a new line from being added
                            handleSendMessage();
                          }
                        }}
              
                        ></textarea>
                        </div>
                        <div className='col-md-1'>
                        <button className="btn btn-primay sendmessage" onClick={handleSendMessage}>
                              <CommonIcon iconName="WandSparkles" size={"17px"} color="#fff"  />
                        </button>
                        </div>
                        </div>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
             </div>
          </div>
       </div>
    </div>
</div>    
                                </div>
                            </div>
                        </div>
                </div>
                </>
                ) : (loader())}
                </>
            </div>
        </div>
    </div>
   )
}